<template>
    <div class="RiskProfileAssignmentInstruction">
        <EidIcon :icon-src="faFileText" />
        <div class="RiskProfileAssignmentInstruction__content">
            <h4>{{ title }}</h4>
            <p>
                {{ description }}
            </p>
        </div>
    </div>
</template>

<style lang="scss">
.RiskProfileAssignmentInstruction {
    display: flex;
    gap: 12px;
    padding: 16px;
    background-color: var(--eidBgGrayTones-lightest);
    border: 1px solid var(--eidTechGray-25);
    border-radius: var(--primary-border-radius);
    cursor: default;

    .EidIcon {
        color: var(--eidTrustGreen);
        border-radius: 8.75px;
        background-color: var(--eidTrustGreen-10);
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__content {
        flex: 1;
    }

    h4 {
        margin: 0 0 8px 0;
        color: var(--eidQualityBlack);
        font-size: 16px;
        font-weight: 600;
    }

    p {
        margin: 0;
        color: var(--eidQualityBlack-75);
        font-size: 14px;
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { faFileText } from '@fortawesome/free-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    export default defineComponent({
        name: 'RiskProfileAssignmentInstruction',
        components: { EidIcon },
        props: {
            title: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                faFileText,
            };
        },
    });
</script>
